<template>
  <div>
    <el-card shadow="never">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px" label-position="top">
        <!-- <el-form-item label="标题一" required prop="title_one">
      <el-input v-model="form.title_one" maxlength="30" show-word-limit></el-input>
    </el-form-item> -->

        <el-form-item label="标题" required prop="title_two">
          <el-input v-model="form.title_two" maxlength="30" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="校区介绍" required prop="content">
          <el-input type="textarea" :rows="4" v-model="form.content" maxlength="200" show-word-limit></el-input>
        </el-form-item>

        <!--
      <el-form-item label="营业时间" required>
        <el-input v-model="form.evermen_two_title" maxlength="30" show-word-limit></el-input>
      </el-form-item>
-->
        <el-form-item label="营业时间" required>
          <el-input v-model="form.evermen_two_content" maxlength="200" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="特色服务" required>
          <el-input v-model="form.evermen_three_content" maxlength="200" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="轮播图" required>
          <el-card shadow="nerver">
            <div>
              <el-upload ref="refUpload" action="" :http-request="uploadFile" :on-remove="handleRemove" :on-change="handleChangeFile" :auto-upload="false" :limit="1" :on-exceed="handleExceed" :file-list="fileList" list-type="picture" style="width: 400px">
                <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
                <div slot="tip" class="el-upload__tip" style="width:600px;">
                  <span>推荐尺寸: 1170px * 550px</span>
                  <span style="margin-left: 10px">
                    只能上传jpg/png文件，且不超过1mb</span>
                </div>
              </el-upload>

              <el-card shadow="never" style="margin-top: 10px;" v-if="tableData.length !== 0">
                <el-table :show-header="false" :data="tableData" style="width: 100%">
                  <el-table-column prop="" label="">
                    <template slot-scope="scope">
                      <el-image style="width: 117px; height: 55px" :src="scope.row" fit="cover"></el-image>
                    </template>
                  </el-table-column>
                  <el-table-column label="">
                    <template slot-scope="scope">
                      <el-button type="danger" icon="el-icon-delete" circle @click="deletePic(scope.row)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div>
          </el-card>
        </el-form-item>

        <el-form-item label="是否显示">
          <el-card shadow="never">
            <el-switch v-model="form.aboutus_is_show" active-text="开启" inactive-text="关闭" @change="changBannge">
            </el-switch>
          </el-card>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit('form')" size="small">保 存</el-button>
          <el-button @click="resetHomepage('3')" size="small">重 置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { updateHomepage, resetHomepage } from '@/api/homeset'
import uploadFile from '@/config/uploadFile'

export default {
  props: {
    aboutus_title_one: String,
    aboutus_title_two: String,
    aboutus_content: String,
    aboutus_imgup_url: String,
    aboutus_imgdown_url: String,
    homepage_id: Number,
    schoolData: Array,
    aboutus_is_show: Boolean,
    aboutus_img_url: [Array, String],
  },

  data() {
    var validatePass = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error('请上传图片'))
      } else {
        callback()
      }
    }

    return {
      tableData: [],
      fileList: [],
      isupimg: false,
      form: {
        aboutus_is_show: true,
        title_one: '',
        title_two: '',
        content: '',
        evermen_two_title: '',
        evermen_two_content: '',
        evermen_three_title: '',
        evermen_three_content: '',
        imgupList: [],
        aboutus_img_url: [],
        imgdownList: [],
      },
      rules: {
        title_one: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { required: true, message: '请输入标题', trigger: 'change' },
          { min: 1, max: 8, message: '长度在 1 到 8 个字符', trigger: 'blur' },
        ],
        title_two: [
          { required: true, message: '请输入口号', trigger: 'blur' },
          { required: true, message: '请输入口号', trigger: 'change' },
        ],
        content: [
          { required: true, message: '请填写内容介绍', trigger: 'blur' },
          { required: true, message: '请填写内容介绍', trigger: 'change' },
        ],
        imgupList: [{ validator: validatePass, trigger: 'change' }],
        imgdownList: [{ validator: validatePass, trigger: 'change' }],
      },
    }
  },

  watch: {
    aboutus_img_url() {
      console.log('关于我们图片')
      console.log(this.tableData)
      console.log(this.aboutus_img_url)

      if (this.aboutus_img_url !== 'null') {
        console.log('已有自定义图片，这里初始化')
        this.tableData = JSON.parse(this.aboutus_img_url)
        // this.tableData.forEach((item, index) => {
        //   this.fileList.push({ url: item, uid: Date.now() + index, status: 'success', name: item.split('/')[item.split('/').length - 1] })
        // })
      }
    },
    aboutus_is_show() {
      this.form.aboutus_is_show = this.aboutus_is_show
    },
    aboutus_title_one() {
      this.form.title_one = this.aboutus_title_one
    },
    aboutus_title_two() {
      this.form.title_two = this.aboutus_title_two
    },
    aboutus_content() {
      this.form.content = this.aboutus_content
    },

    aboutus_imgup_url() {
      this.form.imgupList = [
        {
          url: this.aboutus_imgup_url,
          name: this.aboutus_imgup_url.split('/')[
            this.aboutus_imgup_url.split('/').length - 1
          ],
        },
      ]
    },

    aboutus_imgdown_url() {
      this.form.imgdownList = [
        {
          url: this.aboutus_imgdown_url,
          name: this.aboutus_imgdown_url.split('/')[
            this.aboutus_imgdown_url.split('/').length - 1
          ],
        },
      ]
    },
    schoolData() {
      console.log('this.schoolData')
      console.log(this.schoolData, 11212)
        ; (this.form.evermen_two_title = this.schoolData[5]),
          (this.form.evermen_two_content = this.schoolData[6]),
          (this.form.evermen_three_title = this.schoolData[7]),
          (this.form.evermen_three_content = this.schoolData[8])

      this.form.fileList = [
        {
          url: this.schoolData[2],
          name: this.schoolData[2].split('/')[
            this.schoolData[2].split('/').length - 1
          ],
        },
      ]
    },
  },

  methods: {
    uploadFile() { },

    handleExceed() {
      this.$message.warning('请删除原有文件,再重新上传')
    },

    handleRemove(file, fileList) {
      this.form.imgupList = fileList
      this.removeFile(file)
    },
    removeFile(file) {
      // 使用 Element UI 的 remove 方法移除文件
      this.$refs.refUpload.clearFiles()
      this.fileList = this.fileList.filter((f) => f.uid !== file.uid)
    },

    // handleRemove1(file, fileList) {
    //   this.form.imgdownList = fileList;
    // },

    async handleChangeFile(file, fileList) {
      console.log(file, 12121)
      if (file.size > 1024 * 1024 * 1) {
        // this.fileList.pop()
        this.removeFile(file)
        return this.$message.warning('图片不符合规则，请重新上传！')
      } else {
        if (!this.uploadFileTime) {
          await this.uploadFileOss(fileList)
        }
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          this.fileList = res
          this.uploadFileTime = false
        }
      )
    },
    changBannge(val) {
      console.log(val, 1212)
      console.log(this.form.aboutus_is_show, 1212)
    },
    onSubmit(formName) {
      this.form.aboutus_img_url = this.tableData
      this.fileList.map((item) => {
        this.form.aboutus_img_url.push(item.url)
      })
      if (this.form.aboutus_img_url.join('') === '') {
        return this.$message.warning('请先上传图片')
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateHomepage({
            id: this.homepage_id,
            aboutus_title_one: this.form.title_one,
            aboutus_title_two: this.form.title_two,
            aboutus_content: this.form.content,
            // aboutus_imgup_url: this.form.imgupList[0].url,
            // aboutus_imgdown_url: this.form.imgdownList[0].url,
            aboutus_imgup_url: this.aboutus_imgup_url,
            aboutus_imgdown_url: this.aboutus_imgdown_url,
            aboutus_is_show: this.form.aboutus_is_show === false ? '0' : '1',
            evermen_two_title: this.form.evermen_two_title,
            evermen_two_content: this.form.evermen_two_content,
            evermen_three_title: this.form.evermen_three_title,
            evermen_three_content: this.form.evermen_three_content,
            aboutus_img_url: JSON.stringify(this.form.aboutus_img_url),
          }).then((res) => {
            if (res.is_update) {
              this.fileList = []
              this.$message.success('保存成功！')
            }
          })
        }
      })
    },

    //重置校区信息
    resetHomepage(type) {
      this.$confirm('确定重置关于我们吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        resetHomepage({
          reset_type: type,
        }).then((res) => {
          console.log('重置信息')
          console.log(res)
          if (res.is_update) {
            this.$message.success('重置成功,请刷新本页面')
          }
        })
      })
    },
    //删除
    deletePic(row) {
      this.fileList.splice(this.fileList.indexOf(row), 1)
      this.tableData.splice(this.tableData.indexOf(row), 1)
    },
  },
}
</script>

<style scoped lang="scss">
.table-style {
  margin-top: 20px;
}
</style>
